// APP CONFIG
const bimbelConfig = {
  studenia: {
    appName: "Studenia",
    website: "https://studenia.id",
    instagram: "studenia.id",
    colors: {
      primary: "#5022e2",
      "primary-light": "#805af8",
      secondary: "#82868b",
      info: "#00cfe8",
      warning: "#4b4b4b",
      light: "#adb5bd",
      dark: "#4b4b4b",
    },
  },
  priority: {
    appName: "Priority",
    website: "https://prioritystan.com/",
    instagram: "prioritystan",
    colors: {
      primary: "#1A4B84", // Navy Blue elegan
      "primary-light": "#4A90E2", // Royal Blue terang
      secondary: "#0D1B2A", // Deep Blue gelap
      info: "#5BC0EB", // Soft Sky Blue
      warning: "#FFD600", // Tetap kuning untuk kontras
      light: "#F4F7FA", // Light grey-blue
      dark: "#1C1C1C", // Netral dark
    },
  },
  superlatif: {
    appName: "Superlatif",
    website: "https://superlatif.id/",
    instagram: "superlatif",
    colors: {
      primary: "#03D37B", // brand green
      "primary-light": "#25FCA1", // tint (≈+35% lightness)
      secondary: "#027444", // deeper green for accents
      info: "#47C3F3", // keep consistent info blue
      warning: "#FFD600",
      light: "#F3F7FB",
      dark: "#212121",
    },
  },
};

module.exports = {
  bimbelConfig,
};
